<mat-card class="mat-mdc-card mdc-card cardWithShadow card2 position-relative card-hover">
    <mat-card-content class="mat-mdc-card-content p-y-24">
        <div class="row d-flex justify-content-between">
            <div class="col-md-12 divDownload">
                <a mat-mini-fab class="excel" target="_blank" href="{{api.APIBase}}/data" >
                    <i-tabler name="file-type-xls" class="routeIcon"></i-tabler>
                </a>

            </div>
        </div>
        <div class='content'>
            <div class="count" *ngIf="data.length!=0">{{'Results'| translate}}: {{data.length}} {{'of'| translate}} {{totalItems}}</div>

            <table>
                <thead>
                    <tr>
                        <th>{{'windoRex.title'|translate}}</th>
                        <th>{{'windoRex.fullName'|translate}}</th>
                        <th>{{'windoRex.city'|translate}}</th>
                        <th>{{'windoRex.state'|translate}}</th>
                        <th>{{'Email'|translate}}</th>
                        <th>{{'Phone'|translate}}</th>
                        <th>{{'windoRex.workshopType'|translate}}</th>
                        <th>{{'windoRex.workshopName'|translate}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let user of data">
                        <td>{{user.title}}</td>
                        <td>{{user.fullName}}</td>
                        <td>{{user.city}}</td>
                        <td>{{user.state}}</td>
                        <td>{{user.email}}</td>
                        <td>{{user.phone}}</td>
                        <td>{{Constants.Text(Constants.WorkshopTypes, user.workshopType)}}</td>
                        <td>{{user.workshop}}</td>
                    </tr>

                    <tr *ngIf="data.length==0">
                        <td colspan="8">{{ 'NoDataFound' | translate }}</td>
                    </tr>
                </tbody>
            </table>

        </div>
    </mat-card-content>
</mat-card>
